import { useState as P, useEffect as E, useMemo as i, useCallback as x } from "react";
import { b as I, s as R } from "./localisationConfig-BfnSuGmH.js";
import "react/jsx-runtime";
import "./tailwind-BXrsiEcF.js";
import { AccountType as A, MessageType as M, ConversationPhase as O } from "./types.js";
const c = 768;
function S() {
  const [s, e] = P(void 0);
  return E(() => {
    const u = window.matchMedia(`(max-width: ${c - 1}px)`), n = () => {
      e(window.innerWidth < c);
    };
    return u.addEventListener("change", n), e(window.innerWidth < c), () => u.removeEventListener("change", n);
  }, []), !!s;
}
function C(s) {
  return i(() => ({ ...s != null && s.frontend_expert_output_config ? structuredClone(
    s == null ? void 0 : s.frontend_expert_output_config
  ) : void 0 }), [s == null ? void 0 : s.frontend_expert_output_config]);
}
function $(s, e) {
  const u = C(s), n = u == null ? void 0 : u.enquiry;
  return i(() => {
    var l, p, f, _, w, g, m, h, y;
    const { expert_name: t = "", output_key: r = "" } = (n == null ? void 0 : n.assessment_lights) || {};
    return (p = (l = e == null ? void 0 : e[t]) == null ? void 0 : l.parsed_output) != null && p[r] ? (_ = (f = e == null ? void 0 : e[t]) == null ? void 0 : f.parsed_output) == null ? void 0 : _[r] : (w = e == null ? void 0 : e[t]) != null && w.raw_output ? (g = e == null ? void 0 : e[t]) == null ? void 0 : g.raw_output : (m = e == null ? void 0 : e.assessment_lights_demo) != null && m.raw_output ? (h = e == null ? void 0 : e.assessment_lights_demo) == null ? void 0 : h.raw_output : ((y = e == null ? void 0 : e.assessment_lights) == null ? void 0 : y.raw_output) || "";
  }, [n, e]);
}
const L = {
  councilName: "Yarra Ranges Council",
  councilPhoneNumber: "1300 368 333",
  councilPlanningWebsite: "https://www.yarraranges.vic.gov.au/Development/Planning",
  councilContactLink: "https://www.yarraranges.vic.gov.au/Contact",
  councilWrittenPlanningAdviceLink: "https://www.yarraranges.vic.gov.au/Development/Applications-permits-and-certificates/Apply-for-written-planning-advice",
  councilPrivacyInformationLink: "https://www.yarraranges.vic.gov.au/Council/Corporate-documents/Policies-strategies/Operational-Privacy-Health-Information-Policy",
  councilOrdinanceLink: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/{{}}"
};
function o(s) {
  const e = i(() => s != null && s.localisation_config ? s.localisation_config : L, [s == null ? void 0 : s.localisation_config]);
  return {
    getLocalisationEntry: x(
      (n) => n in e ? I(e, n) : L[n],
      [e]
    )
  };
}
function k(s) {
  const { messages: e, senderAccountType: u } = s || { messages: [] };
  return i(() => e.filter((n) => u ? n.sender_account_type === u : !0).sort(R).at(-1), [e, u]);
}
function q({
  messages: s
}) {
  const e = k({
    messages: s,
    senderAccountType: A.USER
  });
  return (e == null ? void 0 : e.message_type) === M.FOLLOW_UP;
}
function G({
  conversation: s,
  messages: e
}) {
  return q({ messages: e }) || (s == null ? void 0 : s.phase) !== O.report_ready;
}
function Y({
  conversation: s,
  noticeboardData: e
}) {
  const u = C(s), n = u == null ? void 0 : u.enquiry;
  return i(() => {
    var l, p, f, _;
    const { expert_name: t = "", output_key: r = "" } = (n == null ? void 0 : n.missing_information_questions) || {};
    return (p = (l = e == null ? void 0 : e[t]) == null ? void 0 : l.parsed_output) != null && p[r] ? (((_ = (f = e == null ? void 0 : e[t]) == null ? void 0 : f.parsed_output) == null ? void 0 : _[r]) || []).map((g, m) => ({
      id: `${m}-${g.clause_number}`,
      question: g.exemption_text
    })) : [];
  }, [n, e]);
}
function H({ conversation: s }) {
  const e = s == null ? void 0 : s.review;
  return i(() => {
    if (e && !(e != null && e.review_data))
      return [{ ...e, review_data: {} }];
    if (e && typeof e.review_data == "string") {
      const u = JSON.parse(e.review_data || "{}");
      return [{ ...e, review_data: u }];
    } else return e ? [e] : [];
  }, [e]);
}
export {
  $ as a,
  o as b,
  q as c,
  G as d,
  C as e,
  k as f,
  Y as g,
  H as h,
  S as u
};
//# sourceMappingURL=useParsedReviews-4rnmeVis.js.map
